var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 4.422 23.917 15.105",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: " event",
    clipRule: " event",
    d: "M 11.988 11.721 C 13.491 11.721 14.71 10.502 14.71 8.998 C 14.71 7.495 13.491 6.276 11.988 6.276 C 10.485 6.276 9.266 7.495 9.266 8.998 C 9.266 10.502 10.485 11.721 11.988 11.721 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: " event",
    clipRule: " event",
    d: "M 9.346 5.509 C 8.292 6.308 7.612 7.574 7.612 8.998 C 7.612 9.501 7.697 9.982 7.853 10.432 C 7.582 10.509 7.299 10.551 7.005 10.551 C 5.312 10.551 3.94 9.179 3.94 7.487 C 3.94 5.794 5.312 4.422 7.005 4.422 C 7.943 4.422 8.783 4.844 9.346 5.509 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: " event",
    clipRule: " event",
    d: "M 19.774 7.487 C 19.774 9.179 18.402 10.551 16.71 10.551 C 16.502 10.551 16.299 10.531 16.103 10.491 C 16.273 10.025 16.364 9.522 16.364 8.998 C 16.364 7.503 15.615 6.183 14.472 5.394 C 15.03 4.796 15.826 4.422 16.71 4.422 C 18.402 4.422 19.774 5.794 19.774 7.487 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: " event",
    clipRule: " event",
    d: "M 11.959 13.234 C 8.504 13.234 5.63 15.938 5.035 19.503 L 5.04 19.503 C 5.037 19.511 5.036 19.519 5.035 19.527 L 18.882 19.527 C 18.881 19.519 18.88 19.511 18.877 19.503 L 18.882 19.503 C 18.287 15.938 15.413 13.234 11.959 13.234 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "event",
    clipRule: " event",
    d: "M 3.192 18.43 L 0 18.43 C 0.611 14.448 3.56 11.427 7.105 11.427 C 8.186 11.427 9.21 11.706 10.13 12.208 C 7.149 12.923 4.592 15.229 3.192 18.43 Z M 13.871 12.164 C 14.769 11.69 15.765 11.427 16.812 11.427 C 20.357 11.427 23.306 14.448 23.917 18.43 L 21.005 18.43 C 19.573 15.159 16.935 12.823 13.871 12.164 Z",
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.1a9b2aa70feef0a0f0456b25264757d3.svg";
export { ForwardRef as ReactComponent };